import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export default Container;
